import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const crossFilled: ISVGPersonalProps = {
  viewBox: '0 0 15.572 15.572',
  content: (
    <g id="green_cross_icon" data-name="green cross icon" transform="translate(1412.938 -3535.757)">
      <path
        id="Path_1011"
        data-name="Path 1011"
        d="M-1409.565,3551.329l-3.372-3.373,12.2-12.2,3.372,3.372Z"
        transform="translate(0)"
        fill="#1c7903"
      />
      <path
        id="Path_1012"
        data-name="Path 1012"
        d="M3.372,15.572,0,12.2,12.2,0l3.372,3.372Z"
        transform="translate(-1397.366 3535.757) rotate(90)"
        fill="#1c7903"
      />
    </g>
  ),
};
